<div
  class="root"
  [id]="getMessageContentType(message) + '-' + message.id"
  skyTranslationGuard="skypro-communication-message"
  data-test="сообщение обсуждения"
>
  <div class="main-message" [class.-highlight]="isActive" data-test="тред обсуждения">
    <div class="message-info">
      <div class="avatar" [class.is-deleted]="isDeleted">
        <vim-core-user-avatar
          [user]="message.author.user"
          [avatarUrl]="message.author.avatarUrl"
          [size]="32"
        ></vim-core-user-avatar>
      </div>
      <div class="author">
        <div class="author-name" data-test="автор" [class.is-deleted]="isDeleted">
          {{ message.author.user.name }}
        </div>
        @if (message.author.hasTutorIcon) {
          <div class="author-accepted" [class.is-deleted]="isDeleted">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4087 3.1041C11.209 2.04863 12.7957 2.04863 13.596 3.1041L14.2421 3.95613C14.6787 4.53203 15.3921 4.82754 16.1081 4.72909L17.1674 4.58344C18.4797 4.40302 19.6017 5.52499 19.4212 6.83723L19.2756 7.89653C19.1771 8.61253 19.4726 9.32594 20.0485 9.76262L20.9006 10.4087C21.956 11.209 21.956 12.7957 20.9006 13.596L20.0485 14.2421C19.4726 14.6787 19.1771 15.3921 19.2756 16.1081L19.4212 17.1674C19.6017 18.4797 18.4797 19.6017 17.1674 19.4212L16.1081 19.2756C15.3921 19.1771 14.6787 19.4726 14.2421 20.0485L13.596 20.9006C12.7957 21.956 11.209 21.956 10.4087 20.9006L9.76262 20.0485C9.32594 19.4726 8.61253 19.1771 7.89653 19.2756L6.83723 19.4212C5.52499 19.6017 4.40302 18.4797 4.58344 17.1674L4.72909 16.1081C4.82754 15.3921 4.53203 14.6787 3.95613 14.2421L3.1041 13.596C2.04863 12.7957 2.04863 11.209 3.1041 10.4087L3.95613 9.76262C4.53203 9.32594 4.82754 8.61253 4.72909 7.89653L4.58344 6.83722C4.40302 5.52499 5.52499 4.40302 6.83723 4.58344L7.89653 4.72909C8.61253 4.82754 9.32594 4.53203 9.76262 3.95613L10.4087 3.1041Z"
                fill="#61C86D"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.3675 9.39345L11.8675 15.8934C11.6794 16.1158 11.4037 16.2451 11.1124 16.2475C10.8212 16.2499 10.5434 16.1252 10.3516 15.906L6.85156 11.906L8.35672 10.589L11.0914 13.7144L15.8408 8.10156L17.3675 9.39345Z"
                fill="white"
              />
            </svg>
          </div>
        }
      </div>

      <div class="subtitle">
        @if (!isDeleted) {
          <div class="info-group">
            @if (message.isEdited) {
              <div class="edited-label" data-test="метка отредактированного сообщения">
                {{ 'skyproCommunications.edited' | transloco }}
              </div>
            }
          </div>
        }
        @if (hasActions) {
          <div class="actions-group">
            @if (isPinned) {
              <div class="tag -desktop">{{ 'skyproCommunications.pinned' | transloco }}</div>
            }
            @if (isPinned) {
              <div class="tag -mobile">
                <ds-icon-pin-post size="s" class="tag-icon"></ds-icon-pin-post>
              </div>
            }
            @if (canHide && isHidden) {
              <div class="tag -red">{{ 'skyproCommunications.isHidden' | transloco }}</div>
            }
            @if (
              (canDelete || canEdit || canPin || canHide || message.historyLink || canClose) &&
              !isDeleted
            ) {
              <ds-icon-more
                class="more"
                size="m"
                [matMenuTriggerFor]="menu"
                data-test="кнопка меню действий с сообщением"
              ></ds-icon-more>
            }
          </div>
        }
      </div>
      <mat-menu #menu="matMenu">
        @if (canPin && !isPinned && !isDeleted) {
          <button mat-menu-item (click)="pinMessage()" data-test="кнопка закрепить сообщение">
            {{ 'skyproCommunications.pin' | transloco }}
          </button>
        }
        @if (canPin && isPinned && !isDeleted) {
          <button mat-menu-item (click)="unpinMessage()" data-test="кнопка открепить сообщение">
            {{ 'skyproCommunications.unpin' | transloco }}
          </button>
        }
        @if (canHide && !isHidden && !isDeleted) {
          <button mat-menu-item (click)="hideMessage()" data-test="кнопка скрыть сообщение">
            {{ 'skyproCommunications.hide' | transloco }}
          </button>
        }
        @if (canHide && isHidden && !isDeleted) {
          <button mat-menu-item (click)="showMessage()" data-test="кнопка показать сообщение">
            {{ 'skyproCommunications.show' | transloco }}
          </button>
        }
        @if (canEdit && !isDeleted) {
          <button mat-menu-item (click)="editMessage()" data-test="кнопка редактирования сообщения">
            {{ 'skyproCommunications.edit' | transloco }}
          </button>
        }
        @if (message.historyLink) {
          <a mat-menu-item [href]="message.historyLink" target="_blank">
            {{ 'skyproCommunications.history' | transloco }}
          </a>
        }
        @if (canClose) {
          <button mat-menu-item (click)="close.emit()" data-test="закрыть тред">
            {{ 'skyproCommunications.close' | transloco }}
          </button>
        }
        @if (canDelete && !isDeleted) {
          <button
            class="delete-button"
            mat-menu-item
            (click)="deleteMessage()"
            data-test="кнопка удалить сообщение"
          >
            {{ 'skyproCommunications.delete' | transloco }}
          </button>
        }
      </mat-menu>
    </div>

    <div class="message-grid">
      @if (
        { isPreview: isPreview$ | async, needShowPreviewToggler: needShowPreviewToggler$ | async };
        as data
      ) {
        <div class="message">
          @if (!isDeleted) {
            <quill-view-html
              highlightCode
              #messageBodyRef
              data-test="текст сообщения обсуждения"
              class="message-body"
              [content]="getFlatMessageBody(message.body)"
              [sanitize]="true"
              [class.-preview-mode]="data.isPreview && !isCompactPreview"
              [class.-preview-mode-compact]="data.isPreview && isCompactPreview"
            ></quill-view-html>
            @if (data.needShowPreviewToggler) {
              <div class="preview-toggler" (click)="changePreviewMode()">
                @if (data.isPreview && !isCompactPreview) {
                  <span>{{ 'skyproCommunications.showAllQuestionText' | transloco }}</span>
                }
                @if (!data.isPreview && !isCompactPreview) {
                  <span>{{ 'skyproCommunications.showQuestionPreview' | transloco }}</span>
                }
                @if (data.isPreview && isCompactPreview) {
                  <span>{{ 'skyproCommunications.showAllAnswerText' | transloco }}</span>
                }
                @if (!data.isPreview && isCompactPreview) {
                  <span>{{ 'skyproCommunications.showAnswerPreview' | transloco }}</span>
                }
              </div>
            }
            <div class="attachment-grid">
              @for (
                attachment of message.attachments;
                track trackByAttachment($index, attachment)
              ) {
                <skypro-message-attachment-preview
                  class="attachment-item"
                  [url]="attachment.url"
                  [title]="attachment.title"
                ></skypro-message-attachment-preview>
              }
            </div>
          }
          @if (isDeleted) {
            <p class="deleted-message" data-test="текст удаленного сообщения">
              {{ 'skyproCommunications.deleted' | transloco }}
            </p>
          }
        </div>
      }

      <div class="actions">
        <div class="left-side-actions">
          @if (!(isMobile$ | async) && !isDeleted && content) {
            <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
          }
          <ng-content></ng-content>
        </div>
        <div class="right-side-actions">
          @if ((isMobile$ | async) && !isDeleted && content) {
            <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
          }
          @if (!isDeleted) {
            <div class="date-group">
              <div class="time">{{ formatTime() }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
